import React, { useState, useMemo } from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const teal = "#06d1c6";

const inputStyle = {
  padding: "8px 12px",
  border: `1px solid ${teal}`,
  borderRadius: "6px",
  fontSize: "14px",
  width: "100%",
  maxWidth: "100%",
};

const COLUMNS = [
  { key: "invoiceNo", label: "Invoice No.", sort: true, search: true },
  { key: "entity", label: "Entity", sort: true, search: false },
  { key: "invoiceDate", label: "Invoice Date", sort: true, search: false },
  { key: "clientName", label: "Client Name", sort: true, search: true },
  { key: "amount", label: "Amount", sort: true, search: false },
  { key: "remark", label: "Remark", sort: true, search: true },
];

const SAMPLE_ROWS = [
  { id: 1, invoiceNo: "1771243632764", entity: "ARN-315999", invoiceDate: "16-02-2026", clientName: "MANN", amount: "500.00", remark: "" },
  { id: 2, invoiceNo: "1771243626770", entity: "ARN-315999", invoiceDate: "16-02-2026", clientName: "MANN", amount: "200.00", remark: "" },
];

export default function ClientBillRegister() {
  const [selectedUser, setSelectedUser] = useState("");
  const [entity, setEntity] = useState("All");
  const [invoiceDateFrom, setInvoiceDateFrom] = useState("");
  const [invoiceDateTo, setInvoiceDateTo] = useState("");
  const [quotation, setQuotation] = useState(true);
  const [taxInvoice, setTaxInvoice] = useState(false);
  const [sortBy, setSortBy] = useState("invoiceNo");
  const [sortDir, setSortDir] = useState("desc");
  const [selectedId, setSelectedId] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(2);
  const [currentPage, setCurrentPage] = useState(1);

  const rows = SAMPLE_ROWS;
  const totalAmount = useMemo(() => rows.reduce((sum, r) => sum + parseFloat(r.amount || 0), 0).toFixed(2), [rows]);
  const totalRows = rows.length;
  const totalPages = Math.max(1, Math.ceil(totalRows / rowsPerPage));
  const paginatedRows = rows.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const toggleSort = (key) => {
    if (sortBy === key) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    else {
      setSortBy(key);
      setSortDir("desc");
    }
  };

  const SortIcon = ({ columnKey }) => (
    <button
      type="button"
      className="btn btn-link p-0 ms-1 border-0"
      style={{ color: sortBy === columnKey ? teal : "#64748b", fontSize: "11px" }}
      onClick={() => toggleSort(columnKey)}
      aria-label={`Sort by ${columnKey}`}
    >
      <i className={`fa fa-sort-${sortBy === columnKey ? (sortDir === "asc" ? "up" : "down") : "up"}`} style={{ opacity: sortBy === columnKey ? 1 : 0.4 }} />
    </button>
  );

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          <div className="mb-4" style={cardStyle}>
              <div className="content-page-header content-page-headersplit">
                <h5>Client Bill Register</h5>
            </div>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/admin/billing/create-client-bill">Billing</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Client Bill Register
                </li>
              </ol>
            </nav>
          </div>

          {/* Filters */}
          <div style={cardStyle}>
            <h6 className="mb-3 fw-bold" style={{ color: "#334155" }}>Filters :</h6>
            <div className="row g-3 mb-3">
              <div className="col-12 col-md-4">
                <label className="form-label mb-1" style={{ fontSize: "14px", color: "#334155" }}>Select User</label>
                <div className="d-flex align-items-center position-relative">
                  <i className="fa fa-user position-absolute ms-2" style={{ color: teal, fontSize: "14px", zIndex: 1 }} aria-hidden />
                  <select
                    value={selectedUser}
                    onChange={(e) => setSelectedUser(e.target.value)}
                    style={{ ...inputStyle, paddingLeft: "32px" }}
                  >
                    <option value="">Select User</option>
                  </select>
                  <i className="fa fa-chevron-down position-absolute end-0 me-2" style={{ color: "#64748b", fontSize: "12px", pointerEvents: "none" }} aria-hidden />
                </div>
              </div>
              <div className="col-12 col-md-4">
                <label className="form-label mb-1" style={{ fontSize: "14px", color: "#334155" }}>Entity:</label>
                <select value={entity} onChange={(e) => setEntity(e.target.value)} style={inputStyle}>
                  <option value="All">All</option>
                </select>
              </div>
              <div className="col-12 col-md-4">
                <label className="form-label mb-1" style={{ fontSize: "14px", color: "#334155" }}>Invoice Date :</label>
                <div className="d-flex align-items-center gap-2">
                  <div className="d-flex align-items-center flex-1" style={{ minWidth: "100px" }}>
                    <i className="fa fa-calendar-alt me-2" style={{ color: teal, fontSize: "14px" }} aria-hidden />
                    <input
                      type="date"
                      value={invoiceDateFrom}
                      onChange={(e) => setInvoiceDateFrom(e.target.value)}
                      style={inputStyle}
                      placeholder="DD-MM-YYYY"
                    />
                  </div>
                  <span className="text-muted">-</span>
                  <input
                    type="date"
                    value={invoiceDateTo}
                    onChange={(e) => setInvoiceDateTo(e.target.value)}
                    style={{ ...inputStyle, flex: 1, minWidth: "100px" }}
                    placeholder="DD-MM-YYYY"
                  />
                </div>
              </div>
            </div>
            <div className="mb-4">
              <label className="form-label mb-2 d-block" style={{ fontSize: "14px", color: "#334155" }}>Client Bill Type :</label>
              <div className="d-flex gap-4">
                <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer", fontSize: "14px" }}>
                  <input type="checkbox" checked={quotation} onChange={(e) => setQuotation(e.target.checked)} style={{ accentColor: teal }} />
                  Quotation
                </label>
                <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer", fontSize: "14px" }}>
                  <input type="checkbox" checked={taxInvoice} onChange={(e) => setTaxInvoice(e.target.checked)} style={{ accentColor: teal }} />
                  Tax Invoice
                </label>
              </div>
            </div>
            <div className="text-center">
              <button
                type="button"
                className="border-0 rounded px-4 py-2"
                style={{ background: teal, color: "#fff", fontWeight: 600, fontSize: "14px", cursor: "pointer" }}
              >
                Show
              </button>
            </div>
          </div>

          {/* Table */}
          <div style={cardStyle}>
            <div className="d-flex justify-content-end mb-2">
              <button type="button" className="d-flex align-items-center justify-content-center border-0 rounded" style={{ width: 40, height: 40, background: "#f1f5f9", color: "#64748b", cursor: "pointer" }} title="Export to XLS">
                <i className="fa fa-file-excel" style={{ fontSize: "18px" }} />
              </button>
            </div>
            <div style={{ overflowX: "auto" }}>
              <table className="table table-bordered mb-0" style={{ fontSize: "13px" }}>
                <thead>
                  <tr style={{ backgroundColor: "#f8fafc" }}>
                    <th style={{ padding: "10px 12px", width: 50 }}>Select</th>
                    {COLUMNS.map(({ key, label, sort, search }) => (
                      <th
                        key={key}
                        className="text-nowrap"
                        style={{
                          padding: "10px 12px",
                          fontWeight: 600,
                          color: "#334155",
                          backgroundColor: sortBy === key ? "rgba(6, 209, 198, 0.12)" : undefined,
                          borderBottom: sortBy === key ? `2px solid ${teal}` : undefined,
                        }}
                      >
                        {label}
                        {sort && <SortIcon columnKey={key} />}
                        {search && <i className="fa fa-search ms-1" style={{ fontSize: "11px", color: "#94a3b8" }} aria-hidden />}
                      </th>
                    ))}
                    <th style={{ padding: "10px 12px", fontWeight: 600, color: "#334155" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedRows.length === 0 ? (
                    <tr>
                      <td colSpan={COLUMNS.length + 2} style={{ padding: "48px 24px", verticalAlign: "middle" }}>
                        <div className="text-center">
                          <i className="fa-solid fa-triangle-exclamation" style={{ fontSize: "42px", color: "#f59e0b", marginBottom: "8px" }} aria-hidden />
                          <div style={{ fontWeight: 600, color: "#334155" }}>No data available.</div>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    paginatedRows.map((row) => (
                      <tr key={row.id}>
                        <td style={{ padding: "10px 12px", verticalAlign: "middle" }}>
                          <input
                            type="radio"
                            name="billSelect"
                            checked={selectedId === row.id}
                            onChange={() => setSelectedId(row.id)}
                            style={{ accentColor: teal }}
                            aria-label={`Select row ${row.id}`}
                          />
                        </td>
                        <td style={{ padding: "10px 12px" }}>{row.invoiceNo}</td>
                        <td style={{ padding: "10px 12px" }}>{row.entity}</td>
                        <td style={{ padding: "10px 12px" }}>{row.invoiceDate}</td>
                        <td style={{ padding: "10px 12px" }}>{row.clientName}</td>
                        <td style={{ padding: "10px 12px" }}>{row.amount}</td>
                        <td style={{ padding: "10px 12px" }}>{row.remark || "—"}</td>
                        <td style={{ padding: "10px 12px" }}>
                          <button type="button" className="btn btn-link p-0 border-0 text-dark" style={{ fontSize: "16px" }} aria-label="Actions">
                            <i className="fa fa-ellipsis-v" />
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                  {rows.length > 0 && (
                    <tr style={{ backgroundColor: teal, color: "#fff", fontWeight: 700 }}>
                      <td colSpan={4} style={{ padding: "10px 12px" }}>Total</td>
                      <td style={{ padding: "10px 12px" }}>{totalAmount}</td>
                      <td colSpan={2} style={{ padding: "10px 12px" }} />
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {rows.length > 0 && (
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 px-3 py-2 mt-0" style={{ borderTop: "1px solid #e2e8f0", backgroundColor: "#f8fafc" }}>
                <div className="d-flex align-items-center gap-2">
                  <select
                    value={rowsPerPage}
                    onChange={(e) => { setRowsPerPage(Number(e.target.value)); setCurrentPage(1); }}
                    style={{ padding: "4px 8px", border: "1px solid #e2e8f0", borderRadius: "6px", fontSize: "13px" }}
                  >
                    <option value={2}>2</option>
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                  </select>
                  <span style={{ fontSize: "13px", color: "#64748b" }}>rows visible out of {totalRows}.</span>
                </div>
                <div className="d-flex align-items-center gap-1">
                  <button
                    type="button"
                    disabled={currentPage <= 1}
                    onClick={() => setCurrentPage((p) => p - 1)}
                    className="border-0 rounded d-flex align-items-center justify-content-center"
                    style={{ width: 32, height: 32, background: currentPage === 1 ? "#e2e8f0" : teal, color: currentPage === 1 ? "#94a3b8" : "#fff", fontWeight: 700, fontSize: "14px", cursor: currentPage <= 1 ? "not-allowed" : "pointer" }}
                  >
                    ‹
                  </button>
                  <span className="d-flex align-items-center justify-content-center rounded-circle mx-1" style={{ width: 32, height: 32, background: "#22c55e", color: "#fff", fontWeight: 700, fontSize: "13px" }}>{currentPage}</span>
                  <button
                    type="button"
                    disabled={currentPage >= totalPages}
                    onClick={() => setCurrentPage((p) => p + 1)}
                    className="border-0 rounded d-flex align-items-center justify-content-center"
                    style={{ width: 32, height: 32, background: currentPage >= totalPages ? "#e2e8f0" : teal, color: currentPage >= totalPages ? "#94a3b8" : "#fff", fontWeight: 700, fontSize: "14px", cursor: currentPage >= totalPages ? "not-allowed" : "pointer" }}
                  >
                    ›
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
